import * as React from 'react';
import { Head } from 'react-static';

export interface HeadJsonLdProps {
  data: Record<string, unknown>;
}

// react-helmet (used by react-static's <Head>) reads <script> innerHTML from JSX children, not from
// dangerouslySetInnerHTML. The `<` -> `\u003c` escape prevents accidental `</script>` injection.
const serialize = (data: Record<string, unknown>): string => JSON.stringify(data).replace(/</g, '\\u003c');

export const HeadJsonLd = ({ data }: HeadJsonLdProps) => (
  <Head>
    <script type='application/ld+json'>{serialize(data)}</script>
  </Head>
);
